import { GetRowKey, ExpandableConfig, } from 'rc-table/lib/interface';
export { GetRowKey, ExpandableConfig };
